import { ILog } from '../../models/ILog';

export const TODAY_LOG_SEPARATOR_TOP = 'today-log-separator__top-part';
export const TODAY_LOG_SEPARATOR_BOTTOM = 'today-log-separator__bottom-part';
export const MODEL_UPDATED_LOG_SEPARATOR = 'model-updated-separator';

function isToday(date: Date, today: Date) {
    return date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear();
}

export function insertTodayLogSeprator(logs: ILog[], today: Date): ILog[] {
    let records = [...logs];
    const todayRecords = [];
    let onlyToday = true;

    const separators = [
        { id: TODAY_LOG_SEPARATOR_TOP }, { id: TODAY_LOG_SEPARATOR_BOTTOM }
    ] as ILog[];


    for (let i = records.length - 1; i >= 0; i--) {
        const curLog = records[i];
        const prevLog = records[i - 1];

        const curLogDate = new Date(+curLog.ts);

        if (curLog) {
            if (isToday(curLogDate, today)) {
                if (prevLog) {
                    const prevLogDate = new Date(+prevLog.ts);
                    if (curLogDate.getDate() !== prevLogDate.getDate()) {
                        todayRecords.unshift(records.pop());
                        records = [...records];
                        onlyToday = false;
                        break;
                    } else {
                        todayRecords.unshift(records.pop());
                    }
                }

            } else {
                onlyToday = false;
            }
        }
    }

    if (onlyToday) {
        return [...separators, ...logs];
    }
    return [...records, ...separators, ...todayRecords];
}

export function insertModelUpdatedLogSeprator(logs: ILog[]): ILog[] {
    const separator = { id: MODEL_UPDATED_LOG_SEPARATOR } as ILog;

    const result = [];

    for (let i = 0; i < logs.length; i++) {
        result.push(logs[i]);

        if (
            i < logs.length - 1 &&
            logs[i].scriptsHash &&
            logs[i + 1].scriptsHash &&
            logs[i].scriptsHash !== logs[i + 1].scriptsHash
        ) {
            result.push(separator);
        }
    }

    return result;
}